import { Action } from '@reduxjs/toolkit';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';

import { get } from '@eika-infrastruktur/request';
import { LinkButton, StandardButton } from '@eika/button';

import { getRequestOptions, updateValidSession } from '../../meldskade/reducer/skademelding-actions';
import { hentKeepAliveUrl } from '../../urler';
import { generateDataTrackIdForAction, SideDetail } from '../../utils/piwik-utils';

import './step-navigation.scss';

interface Props {
    isOppsummering?: boolean;
    bankregnr: string;
    sideDetail: SideDetail;
    next: {
        text?: string;
        onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
        disabled?: boolean;
        hidden?: boolean;
    };
    prev: {
        text?: string;
        onClick: () => void;
        disabled?: boolean;
    };
    shouldRouteToFremtind?: boolean;
}

export const StepNavigation = ({
    next,
    prev,
    sideDetail,
    isOppsummering = false,
    bankregnr,
    shouldRouteToFremtind = false,
}: Props) => {
    const dispatch: Dispatch<Action> = useDispatch();
    const keepAlive = async () => {
        try {
            await get(hentKeepAliveUrl(), getRequestOptions(bankregnr));
        } catch (e) {
            if (e.status.valueOf() === 401) {
                dispatch(updateValidSession());
            }
        }
    };

    const onNextClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (!isOppsummering) {
            keepAlive();
        }
        next.onClick(event);
    };

    return (
        <div className="step-navigation">
            {shouldRouteToFremtind ? null : (
                <>
                    <LinkButton
                        id="step-navigation-tilbake"
                        className="step-navigation-tilbake-button"
                        type="button"
                        onClick={prev.onClick}
                        data-track-id={generateDataTrackIdForAction('button-previous', sideDetail)}
                    >
                        {prev.text || 'Forrige'}
                    </LinkButton>
                    {!next.hidden && (
                        <StandardButton
                            disabled={next.disabled}
                            id="step-navigation-neste"
                            type="submit"
                            onClick={onNextClick}
                            data-track-id={generateDataTrackIdForAction('button-next', sideDetail)}
                        >
                            {next.text || 'Neste'}
                        </StandardButton>
                    )}
                </>
            )}
        </div>
    );
};
